import * as pubsub from 'pubsub';
import { Controller } from 'stimulus';

export class ObserverController extends Controller {
  static targets = ['item'];

  #instance = null;

  connect() {
    this.#instance = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          pubsub.publish('products:card:visible', { id: entry.target.dataset.id });
          this.#instance.unobserve(entry.target);
        }
      });
    });

    this.itemTargets.forEach((item) => this.#instance.observe(item));
  }
}

window.Stimulus.register('observer', ObserverController);
